import { Component, Input, Output, EventEmitter } from "@angular/core";

export interface DownloadProgress {
  current: number;
  total: number;
  percentage: number;
  currentFile: string;
  status: "downloading" | "completed" | "error" | "idle" | "preparing";
  message: string;
}

@Component({
  selector: "app-download-progress",
  templateUrl: "./download-progress.component.html",
  styleUrls: ["./download-progress.component.scss"],
})
export class DownloadProgressComponent {
  @Input() progress: DownloadProgress = {
    current: 0,
    total: 0,
    percentage: 0,
    currentFile: "",
    status: "idle",
    message: "",
  };

  @Input() visible = false;
  @Output() cancelDownload = new EventEmitter<void>();

  get progressBarWidth(): string {
    return `${this.progress.percentage}%`;
  }

  get statusClass(): string {
    return `status-${this.progress.status}`;
  }

  onCancel(): void {
    this.cancelDownload.emit();
  }

  onClose(): void {
    this.cancelDownload.emit();
  }
}
